import * as React from 'react';
import { Grid, GridList, GridListTile, GridListTileBar, Typography } from '@material-ui/core';

interface ICarrierLogoNameComponentProps {
	logo: string;
	name: string;
}

const CarrierLogoNameComponent: React.FunctionComponent<ICarrierLogoNameComponentProps> = (
	props: ICarrierLogoNameComponentProps
) => {
	return (
		<GridList cols={1} className='selected-carrier-tile'>
			<GridListTile>
				<div className='carriers-tile'>
					<img src={props.logo} className='carrier-img' />
				</div>
				<GridListTileBar
					style={{
						backgroundColor: 'transparent',
						height: '30px',
					}}
					title={
						<Grid container={true} justifyContent='center' alignItems='center'>
							<Grid item={true}>
								<Typography variant='caption' color='textSecondary' noWrap={true}>
									<strong>{props.name}</strong>
								</Typography>
							</Grid>
						</Grid>
					}
				/>
			</GridListTile>
		</GridList>
	);
};

export default CarrierLogoNameComponent;



// WEBPACK FOOTER //
// ./src/components/carriers/carrier-logo-name.component.tsx